
import { returnDecisionStatusName } from '@/plugins/enums/return';
import { orderPaymentStatus } from '@/plugins/enums/order';
import { getPaymentStatusName } from '@/plugins/helpers/order';

export default {
  name: 'ProductTags',

  props: {
    items: {
      type: Array,
      required: true,
    },
    lgSpace: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      returnDecisionStatusName,
      orderPaymentStatus,
    }
  },

  computed: {
    itemsInLowerCase() {
      return this.items.map(item => item.toLowerCase());
    },
  },

  methods: {
    getPaymentStatusName,
    getColorByBudgeName(name) {
      const greens = [
        'новинка',
        this.getPaymentStatusName(orderPaymentStatus.PAID).toLowerCase(),
        returnDecisionStatusName.CONFIRMED.toLowerCase(),
        returnDecisionStatusName.CONFIRMED_MONEY.toLowerCase(),
      ];
      const lightReds = ['отменен', 'экономия'];
      const reds = ['просрочен'];
      const lightRedNameIncludes = ['экономия'];
      const redNameIncludes = ['%', '-', 'выгода'];

      if(greens.includes(name)) {
        return 'green';
      } else if(lightReds.includes(name) || lightRedNameIncludes.some(incItem => name.includes(incItem))) {
        return 'light-red';
      } else if(reds.includes(name) || redNameIncludes.some(incItem => name.includes(incItem))) {
        return 'red';
      }

      return 'gray';
    },
  },
}
